import { API_ENDPOINTS } from '@/shared/libs/api-config';
import { httpClient } from '@/shared/libs/http-client';
import type {
  AuthResponse,
  LoginCredentials,
  SetPasswordRequest,
  SetPasswordResponse,
  UpdateProfileRequest,
  UpdateProfileResponse,
} from '../types/auth.types';

export async function loginRequest(credentials: LoginCredentials): Promise<AuthResponse> {
  return httpClient.post<AuthResponse>(API_ENDPOINTS.auth.login, credentials, {
    skipAuth: true,
  });
}

export async function refreshRequest(refreshToken: string): Promise<AuthResponse> {
  return httpClient.post<AuthResponse>(
    API_ENDPOINTS.auth.refresh,
    { refreshToken },
    {
      skipAuth: true,
    },
  );
}

/**
 * Finalise le mot de passe d'un compte invité / réinitialisé depuis le token
 * de lien de l'email (flux implicite : access_token + refresh_token du
 * fragment `#`). Exécuté côté serveur ONIRIA en client Supabase anon — aucun
 * Bearer à fournir depuis la SPA.
 */
export async function setPasswordRequest(input: SetPasswordRequest): Promise<SetPasswordResponse> {
  return httpClient.post<SetPasswordResponse>(API_ENDPOINTS.auth.setPassword, input, {
    skipAuth: true,
  });
}

/** Met à jour le nom affiché du profil (`PATCH /api/v2/profile`, Bearer). */
export async function updateProfileRequest(
  displayName: UpdateProfileRequest['displayName'],
): Promise<UpdateProfileResponse> {
  return httpClient.patch<UpdateProfileResponse>(API_ENDPOINTS.profile.update, { displayName });
}
